import { useCallback, useState } from 'react'
import { Link } from 'react-router-dom'
import { X } from 'lucide-react'
import {
  applyClarityCookieConsent,
  hasPdsCookieConsent,
  PDS_COOKIE_CONSENT_KEY,
} from '../lib/analytics/clarity'

function hasConsent(): boolean {
  return hasPdsCookieConsent()
}

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(() => !hasConsent())

  const dismiss = useCallback(() => {
    try {
      localStorage.setItem(PDS_COOKIE_CONSENT_KEY, '1')
    } catch {
      /* ignore private mode / quota */
    }
    applyClarityCookieConsent(true)
    setVisible(false)
  }, [])

  if (!visible) return null

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[100] border-t border-ink/10 bg-paper/92 backdrop-blur-md dark:bg-paper/95"
      role="region"
      aria-label="Informacja o plikach cookie"
    >
      <div className="container-x relative py-3 pr-10 sm:pr-12 sm:py-3.5">
        <button
          type="button"
          onClick={dismiss}
          className="absolute right-4 top-3 rounded-lg p-1 text-ink/40 transition-colors hover:bg-ink/5 hover:text-ink/70 sm:right-8 sm:top-3.5"
          aria-label="Zamknij informację o cookies"
        >
          <X className="size-4" strokeWidth={2} aria-hidden />
        </button>

        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
          <p className="max-w-3xl text-[13px] font-semibold leading-snug text-muted sm:text-sm">
            Korzystamy z plików cookie m.in. do działania serwisu i zapamiętywania
            ustawień. Możesz zaakceptować lub przeczytać więcej w{' '}
            <Link
              to="/polityka-prywatnosci"
              className="text-ink/75 underline decoration-ink/20 underline-offset-[3px] hover:text-ink"
            >
              polityce prywatności
            </Link>
            .
          </p>
          <button
            type="button"
            onClick={dismiss}
            className="shrink-0 self-start rounded-lg border border-ink/12 bg-paper px-3 py-1.5 text-xs font-bold text-ink/85 shadow-sm transition-colors hover:bg-ink/[0.04] sm:self-auto sm:text-sm"
          >
            Rozumiem
          </button>
        </div>
      </div>
    </div>
  )
}
